<template>
	<div v-if="!loading">
		<h3 class="staking-status">
			<img
				class="staking-status-icon"
				:src="staking ? require('@/assets/images/board-control/staked_icon.png') : require('@/assets/images/board-control/not_staked_icon.png')"
				alt="">
			{{ staking ? "STAKED" : "NOT STAKED" }}
		</h3>
		<!-- <h3 class="staking-status">
			<img
				class="staking-status-icon"
				:src="staking ? require('@/assets/images/board-control/staked_icon.png') : require('@/assets/images/board-control/not_staked_icon.png')"
				alt="">
			{{ staking ? "STAKED" : "NOT STAKED" }}
		</h3> -->
		<!-- <h4 v-if="staking">
			PENDING REWARD: <span>{{ pendingReward }} $K9</span>
		</h4> -->
		<!-- <h4>
			DAILY REWARD: <span>{{ dailyReward }} $K9</span>
		</h4> -->
		<!-- <div class="staking-actions">
			<div v-if="!staking">
				<button
					class="button_basic"
					:disabled="pending"
					@click.prevent="createStakingMutation">
					<img
						:src="require('@/assets/images/board-control/stake.png')"
						class="no_lazy"
						alt="">
				</button>
			</div>
			<div v-else>
				<div class="hint">
					<p>You can unstake your rewards the 15th june 2022.<br>Before this date, the $K9 rewards will be pending.<br>Selling or transfering your Bulldroid before this date will result in a loss of reward.</p>
				</div>
				<button
					class="button_basic"
					disabled
					@click.prevent="">
					<img
						:src="require('@/assets/images/board-control/unstake.png')"
						class="no_lazy"
						alt="">
				</button>
			</div>
			<div>
				<button
					class="button_basic"
					@click.prevent="staking_infos_modal = true">
					<img
						:src="require('@/assets/images/board-control/info.png')"
						class="no_lazy"
						alt="">
				</button>
			</div>
		</div> -->

		<!-- <Modal
			v-show="staking_infos_modal"
			title="Infos"
			@close="staking_infos_modal = false">
			<template #body>
				<p>To be rewarded with your Bulldroids, you should have clicked on the "Stake" button. You will get daily rewards based on the rarity off your Bulldroid.</p>
				<ul>
					<li>Common: 20 $K9 / day</li>
					<li>Uncommon: 30 $K9 / day</li>
					<li>Rare: 50 $K9 / day</li>
					<li>Epic: 80 $K9 / day</li>
					<li>Legendary: 110 $K9 / day</li>
					<li>Founder: 150 $K9 / day</li>
				</ul>
				<p>You can unstake your rewards the 15th june 2022.<br>Before this date, the $K9 rewards will be pending.<br>Selling or transfering your Bulldroid before this date will result in a loss of reward.</p>
			</template>
		</Modal> -->
	</div>
</template>

<script setup>
// import { ref } from 'vue';

import { useStaking } from '@/composables/staking';

// import Modal from '@/components/Layout/Modal.vue';

const props = defineProps({
	bulldroid: {
		type: Object,
		required: true,
	},
	account: {
		type: String,
		required: true,
	},
});

const {
	loading,
	// pending,
	// dailyReward,
	// pendingReward,
	// staking,

	// createStakingMutation,
} = useStaking(props.account, props.bulldroid);

// const staking_infos_modal = ref(false);
const staking = false;
</script>
